<template>
    <div>
        <page-title title_text="درخواست پول" icon="money_request">
            <router-link to="/money-request-create/bill" class="btn btn-success shadow-sm mx-2 px-4 py-2"
                         style="border-radius: 20px; border-color: #bbb;">
                <span class="pr-2">درخواست جدید</span>
            </router-link>
        </page-title>

        <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px;">
            <div class="row">
                <div class="col-sm my-2">
                    <input class="form-control" placeholder="مبلغ" v-model="filter_amount">
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <select class="form-control kt-selectpicker" id="filter_payment_method"
                                v-model="filter_payment_method">
                            <option :value="null" disabled selected>روش پرداخت</option>
                            <option class="text-secondary" value="1">درگاه اینترنتی</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <select class="form-control kt-selectpicker" id="filter_status" v-model="filter_status">
                            <option :value="null" disabled selected>وضعیت</option>
                            <option class="text-secondary"
                                    :value="moneyRequestStatus.INIT"
                                    v-text="moneyRequestStatusStr.get(moneyRequestStatus.INIT)"
                            ></option>
                            <option class="text-secondary"
                                    :value="moneyRequestStatus.SUCCEEDED"
                                    v-text="moneyRequestStatusStr.get(moneyRequestStatus.SUCCEEDED)"
                            ></option>
                            <option class="text-secondary"
                                    :value="moneyRequestStatus.PAID"
                                    v-text="moneyRequestStatusStr.get(moneyRequestStatus.PAID)"
                            ></option>
                            <option class="text-secondary"
                                    :value="moneyRequestStatus.CANCELLED"
                                    v-text="moneyRequestStatusStr.get(moneyRequestStatus.CANCELLED)"
                            ></option>
                            <option class="text-secondary"
                                    :value="moneyRequestStatus.FAILED"
                                    v-text="moneyRequestStatusStr.get(moneyRequestStatus.FAILED)"
                            ></option>
                        </select>
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <datePicker
                                clearable
                                color="#00c1a4"
                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                format="YYYY-MM-DD HH:mm:ss"
                                input-class="form-control"
                                name="filter_from_date"
                                placeholder="از تاریخ"
                                type="datetime"
                                v-model="filter_from_date"/>
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <datePicker
                                clearable
                                color="#00c1a4"
                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                format="YYYY-MM-DD HH:mm:ss"
                                input-class="form-control"
                                name="filter_from_date"
                                placeholder="تا تاریخ"
                                type="datetime"
                                v-model="filter_to_date"/>
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div>
                        <button :class="query ? 'btn btn-success mr-2' : 'btn btn-success btn-block'"
                                @click="get_data(money_requests.first_page_url)"
                                style="border-radius: 10px;">اعمال فیلتر
                        </button>
                        <button @click="reset_and_get" class="btn btn-danger mr-3"
                                style="border-radius: 10px;" v-if="query">حذف فیلتر
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px;" v-if="is_init">

            <div class="px-3">
                <div class="table-responsive">
                    <table class="table  table-responsive table-borderless text-center"
                           v-if="money_requests.data.length > 0">
                        <thead>
                        <tr>
                            <th scope="col" style="background-color: #eee;  border-radius: 0 16px 16px 0;">#</th>
                            <th scope="col" style="background-color: #eee;">پرداخت‌کننده</th>
                            <th @click="sortBy('amount')" scope="col" style="background-color: #eee; cursor: pointer;">
                                <span class="mx-2">مبلغ (ريال)</span>
                                <span v-if="sort_field == 'amount'">
                  <span v-if="sort_sort == 'asc'">
                    <svg fill="#00bea5" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path
                            d="M0 0h24v24H0V0z" fill="none"/><path
                            d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"/></svg>
                  </span>
                  <span v-else>
                    <svg fill="#00bea5" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path
                            d="M0 0h24v24H0V0z" fill="none"/><path
                            d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"/></svg>
                  </span>
                </span>
                            </th>
                            <th scope="col" style="background-color: #eee">توضیحات</th>
                            <th scope="col" style="background-color: #eee">روش پرداخت</th>
                            <th @click="sortBy('created_at')" scope="col"
                                style="background-color: #eee; cursor: pointer;">
                                <span class="mx-2">تاریخ ایجاد</span>
                                <span v-if="sort_field == 'created_at'">
                  <span v-if="sort_sort == 'asc'">
                    <svg fill="#00bea5" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path
                            d="M0 0h24v24H0V0z" fill="none"/><path
                            d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"/></svg>
                  </span>
                  <span v-else>
                    <svg fill="#00bea5" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path
                            d="M0 0h24v24H0V0z" fill="none"/><path
                            d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"/></svg>
                  </span>
                </span>
                            </th>
                            <th scope="col" style="background-color: #eee;">وضعیت</th>
                            <th scope="col" style="background-color: #eee; border-radius:16px 0 0 16px ;">عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" v-for="(money_request, index) in money_requests.data">
                            <td class="en_num">{{ money_request.hashid }}</td>
                            <td>{{ money_request.payer_full_name }}</td>
                            <td>{{ money_request.amount }}</td>
                            <td>{{ money_request.description }}</td>
                            <td>
                <span :class="'label label-inline' + ' label-light-info'" v-if="money_request.payment_method  == 1">
                    درگاه اینترنتی
                </span><span :class="'label label-inline' + ' label-light-warning'"
                             v-else-if="money_request.payment_method  == 0">
                    پرداخت شناسه‌دار
                </span>
                                <span :class="'label label-inline' + ' label-light-danger'" v-else>
                        نامعلوم
                </span>
                            </td>
                            <td v-text="toPersianDateFormat(money_request.created_at)"></td>
                            <td>
                <span :class="'label label-inline label-light-' + moneyRequestStatusVariant(money_request.status)"
                      v-text="moneyRequestStatusStr.get(money_request.status)"
                >
                </span>
                            </td>
                            <td>
                                <div class="btn-group" v-if="money_request.status === moneyRequestStatus.SUCCEEDED">
                                    <a :href="money_request.pay_link"
                                       class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
                                       target="_blank">
                                        <span class="tooltip-text">{{ $t('label.pay_facture') }}</span>
                                        <svg fill="#bbb" height="24" viewBox="0 0 24 24"
                                             width="24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 0h24v24H0V0z" fill="none"/>
                                            <path d="M21 2.21c-.13 0-.26.05-.35.15l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.8-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.09-.09-.22-.14-.35-.14V21.8c.13 0 .26-.05.35-.15l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.1.1.23.15.35.15V2.21zM17 17H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"/>
                                        </svg>
                                    </a>
                                </div>
                                <div class="btn-group" v-else>
                                    <button @click="remindPayer(money_request.hashid)"
                                            class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
                                            target="_blank"
                                            type="button">
                                        <span class="tooltip-text">یادآوری مجدد به پرداخت کننده</span>
                                        <svg fill="#bbb" height="24" viewBox="0 0 24 24"
                                             width="24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 0h24v24H0V0z" fill="none"/>
                                            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71L18 16z"/>
                                        </svg>
                                    </button>
                                    <button @click="copyLink(money_request.pay_link)"
                                            class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
                                            target="_blank"
                                            type="button">
                                        <span class="tooltip-text">کپی کردن لینک</span>
                                        <svg fill="#bbb" height="15px" viewBox="0 0 24 24" width="15px"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 0h24v24H0V0z" fill="none"/>
                                            <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                                        </svg>
                                    </button>
                                    <a :href="money_request.pay_link"
                                       class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
                                       target="_blank">
                                        <span class="tooltip-text">{{ $t('label.pay_link') }}</span>
                                        <svg enable-background="new 0 0 24 24" fill="#bbb"
                                             height="24" viewBox="0 0 24 24" width="24"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <g>
                                                <rect fill="none" height="24" width="24"/>
                                            </g>
                                            <g>
                                                <path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12.88,17.76v0.36c0,0.48-0.39,0.88-0.88,0.88h0 c-0.48,0-0.88-0.39-0.88-0.88v-0.42c-0.63-0.15-1.93-0.61-2.69-2.1c-0.23-0.44-0.01-0.99,0.45-1.18l0.07-0.03 c0.41-0.17,0.87,0,1.08,0.39c0.32,0.61,0.95,1.37,2.12,1.37c0.93,0,1.98-0.48,1.98-1.61c0-0.96-0.7-1.46-2.28-2.03 c-1.1-0.39-3.35-1.03-3.35-3.31c0-0.1,0.01-2.4,2.62-2.96V5.88C11.12,5.39,11.52,5,12,5h0c0.48,0,0.88,0.39,0.88,0.88v0.37 c1.07,0.19,1.75,0.76,2.16,1.3c0.34,0.44,0.16,1.08-0.36,1.3l0,0C14.32,9,13.9,8.88,13.66,8.57c-0.28-0.38-0.78-0.77-1.6-0.77 c-0.7,0-1.81,0.37-1.81,1.39c0,0.95,0.86,1.31,2.64,1.9c2.4,0.83,3.01,2.05,3.01,3.45C15.9,17.17,13.4,17.67,12.88,17.76z"/>
                                            </g>
                                        </svg>
                                    </a>
                                </div>
                                <div class="btn-group" v-if="money_request.status === moneyRequestStatus.INIT ||
                money_request.status === moneyRequestStatus.PAID ||
                money_request.status === moneyRequestStatus.CANCELLED">
                                    <button type="button"
                                            class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="dropdown"
                                            data-target="#myModal">
                                        <i class="fas fa-cog"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <button v-if="money_request.status === moneyRequestStatus.INIT || money_request.status === moneyRequestStatus.PAID"
                                                id="change_status_to_cancelled"
                                                @click="changeStatus(money_request.hashid, moneyRequestStatus.CANCELLED)"
                                                class="dropdown-item text-white-in-dark-mode"
                                        >
                                            {{ $t('label.money_request.change_status_to_cancelled') }}
                                        </button>
                                        <button v-if="money_request.status === moneyRequestStatus.PAID || money_request.status === moneyRequestStatus.CANCELLED"
                                                id="change_status_to_init"
                                                @click="changeStatus(money_request.hashid, moneyRequestStatus.INIT)"
                                                class="dropdown-item text-white-in-dark-mode"
                                        >
                                            {{ $t('label.money_request.change_status_to_init') }}
                                        </button>
                                        <button
                                                v-if="money_request.status === moneyRequestStatus.INIT || money_request.status === moneyRequestStatus.CANCELLED"
                                                id="change_status_to_paid"
                                                @click="changeStatus(money_request.hashid,moneyRequestStatus.PAID)"
                                                class="dropdown-item text-white-in-dark-mode"
                                        >
                                            {{ $t('label.money_request.change_status_to_paid') }}
                                        </button>
                                    </div>
                                </div>
                                <div class="btn-group">
                                    <a @click="appendDataToModal(money_request, index)"
                                       class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
                                       data-target="#description_modal"
                                       data-toggle="modal" type="button">
                                        <span class="tooltip-text">{{ $t('label.detail_money_request') }} </span>
                                        <i class="fas fa-info-circle"></i>
                                    </a>
                                </div>
                                <div class="btn-group"
                                     v-if="money_request.payment_method === 0 && money_request.status !== moneyRequestStatus.SUCCEEDED &&
                                      money_request.has_transaction">
                                    <a @click="billInquiry(money_request.hashid)"
                                       class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
                                       type="button">
                                        <span class="tooltip-text">{{ bill_inquiry_title }} </span>
                                        <i class="fas fa-sync"></i>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="empty-table" style="height: 300px" v-else>
                        <table class="table table-responsive table-borderless text-center">
                            <thead>
                            <tr>
                                <th scope="col" style="background-color: #eee;  border-radius: 0 16px 16px 0;">#</th>
                                <th scope="col" style="background-color: #eee;">پرداخت‌کننده</th>
                                <th scope="col" style="background-color: #eee;">مبلغ (ريال)</th>
                                <th scope="col" style="background-color: #eee;">توضیحات</th>
                                <th scope="col" style="background-color: #eee;">تاریخ ایجاد</th>
                                <th scope="col" style="background-color: #eee;">وضعیت</th>
                                <th scope="col" style="background-color: #eee; border-radius:16px 0 0 16px ;">عملیات
                                </th>
                            </tr>
                            </thead>
                        </table>
                        <div class="not-found" style="margin: 0 auto;">

                            <img src="@/assets/new/image/not-found_new.png" width="200">
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="money_requests.next_page_url || money_requests.prev_page_url">

            <pagination :data="money_requests" :get_data="get_data" :perpage="perpage"></pagination>
        </div>

        <div id="overlay" v-if="status == 'loading'">
            <div class="p-3" style="position: absolute;
  top: 50%;
  left: 50%;
  color: gray;
  background-color: white;
">
                <div class="spinner-border text-success" role="status">
                </div>
                <span>
          لطفا صبر کنید
        </span>
            </div>
        </div>
        <div>
            <div class="modal fade rtl" id="description_modal" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div id="title">
                            </div>
                            <button class="close float-right mr-0" data-dismiss="modal" type="button">&times;</button>
                        </div>
                        <div class="modal-body mb-4" id="data_sheet">
                            <table class="table table-hover">
                                <thead id="table-header">
                                <tr>
                                    <th class="table-info" colspan="2">{{ $t('label.detail_money_request') }}</th>
                                </tr>
                                </thead>
                                <tbody id="transaction_detail">
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ShopApiService, ivrService, moneyRequestService} from "@/common/api.service";
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import Pagination from "@/components/main/pagination";
import PageTitle from "@/components/main/components/pageTitle";
import toastr from "toastr";
import {moneyRequestStatus, moneyRequestStatusStr, moneyRequestStatusVariant} from "@/constants/MoneyRequestStatus";

export default {
    components: {PageTitle, Pagination},
    data() {
        return {
            moneyRequestStatus,
            moneyRequestStatusStr,
            moneyRequestStatusVariant,
            bill_inquiry_title: " استعلام قبض",
            payment_receipt: "",
            perpage: {
                value: 15,
            },
            is_init: false,
            status: 'loading',
            money_requests: null,
            filter_amount: null,
            filter_payment_method: null,
            filter_pay_id: null,
            filter_bill_id: null,
            filter_status: null,
            filter_from_date: null,
            filter_to_date: null,
            sort_field: null,
            sort_sort: 'desc',
        }
    },
    computed: {
        query() {
            let res = '';
            if (this.filter_amount != null) {
                res = res + '&query[amount]=' + this.filter_amount;
            }
            if (this.filter_payment_method != null) {
                res = res + '&query[payment_method]=' + this.filter_payment_method;
            }
            if (this.filter_status != null) {
                res = res + '&query[status]=' + this.filter_status;
            }
            if (this.filter_from_date != null) {
                res = res + '&query[from_date]=' + this.filter_from_date;
            }
            if (this.filter_to_date != null) {
                res = res + '&query[to_date]=' + this.filter_to_date;
            }
            if (this.filter_bill_id != null) {
                res = res + '&query[bill_id]=' + this.filter_bill_id;
            }
            if (this.filter_pay_id != null) {
                res = res + '&query[pay_id]=' + this.filter_pay_id;
            }
            if (this.sort_field != null) {
                res = res + '&sort[field]=' + this.sort_field + '&sort[sort]=' + this.sort_sort;
            }

            return res;
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        changeStatus(hashid, status) {
            let params = {
                'status': status,
            };

            moneyRequestService.changeStatus(hashid, params).then(response => {
                this.toastr.success(response.data.message);
            }).catch(({response}) => {
                this.toastr.fail(response.data.message);
            }).finally(() => {
                this.reset_and_get();
            });
        },

        copyLink(TextToCopy) {
            let TempText = document.createElement("input");
            TempText.value = TextToCopy;
            document.body.appendChild(TempText);
            TempText.select();

            document.execCommand("copy");
            document.body.removeChild(TempText);
        },
        appendDataToModal(money_request, index) {
            function simpleText(data, title) {
                return '<tr><td style="width: 155px;">' + title + '</td>' +
                        '<td>' + data + '</td></tr>'
            }

            function simpleTextLtr(data, title) {
                return '<tr>' +
                        '<td style="width: 155px;">' + title + '</td>' +
                        '<td style="direction: ltr;">' + data + '</td>' +
                        '</tr>'
            }

            let transaction_detail = $('#transaction_detail').empty()
            let title = $('#title').empty()
            let ps_elements =
                    '<h4 class="modal-title float-left p-0 m-0">' +
                    i18n.t('label.money_request_label') + '</h4>'
            title.append(ps_elements)
            ps_elements = ''
            ps_elements = simpleTextLtr(money_request.payer_phone_number, i18n.t('label.payer_phone_number'))
            transaction_detail.append(ps_elements)
            ps_elements = simpleTextLtr(money_request.payer_wage, i18n.t('label.payer_wage'))
            transaction_detail.append(ps_elements)
            ps_elements = simpleTextLtr(money_request.tracking_number, i18n.t('label.tracking_number'))
            transaction_detail.append(ps_elements)

            if (money_request.details.bill_id) {
                ps_elements = simpleTextLtr(money_request.details.bill_id, i18n.t('label.bill_id'))
                transaction_detail.append(ps_elements)
            }
            if (money_request.details.pay_id) {
                ps_elements = simpleTextLtr(money_request.details.pay_id, i18n.t('label.pay_id'))
                transaction_detail.append(ps_elements)
            }
        },
        toPersianDateFormat(val) {
            if (val == undefined || val == null || val == '') {
                return '';
            }

            val = String(val);

            return val.replace(/\-/g, "/");
        },
        sortBy(field) {
            this.sort_field = String(field);

            if (this.sort_sort == 'desc') {
                this.sort_sort = 'asc';
            } else {
                this.sort_sort = 'desc';
            }

            this.get_data(this.money_requests.path + '?page=1');
        },
        remindPayer(hashid) {
            moneyRequestService.remind(hashid).then(response => {
            }).catch(({response}) => {
            });
        },
        resetQuery() {
            this.filter_amount = null;
            this.filter_payment_method = null;
            this.filter_status = null;
            $('[data-id="filter_status"] .filter-option-inner-inner').text('وضعیت');
            $('[data-id="filter_payment_method"] .filter-option-inner-inner').text('روش پرداخت');

            this.filter_from_date = null;
            this.filter_to_date = null;
            this.filter_pay_id = null;
            this.filter_bill_id = null;
        },
        get_data(url, callback = () => {
        }) {
            this.status = 'loading'
            ShopApiService.query(url + this.query + '&perpage=' + this.perpage.value)
                    .then(json => {
                        this.money_requests = json.data.data;
                        this.status = 'ok'
                        callback();
                    })
        },
        billInquiry(hashid) {
            this.status = 'loading'
            ivrService.billInquiry(hashid).then(response => {
                if (response.data.data.payment_status == this.moneyRequestStatus.PAID)
                    return this.toastr.success(response.data.message)
                else
                    return this.toastr.error(response.data.message)
            }).catch(({res}) => {
                this.toastr.error(res.data.message)
            }).finally(this.get_data(this.money_requests.first_page_url))
        },
        reset_and_get() {
            this.resetQuery();
            this.get_data(this.money_requests.path + '?page=1');
        },

    },
    mounted() {
        ShopApiService.get('money-request/fetch', '').then(json => {
            this.money_requests = json.data.data;
            this.is_init = true;
            this.status = 'ok';
            setTimeout(function () {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 1000);
        });
        if (this.$route.params.type && this.$route.params.type == 'bill') {
            this.filter_payment_method = 0;
            $('#filter_payment_method').val(0).change()
        }
    }
}
</script>

<style>
#overlay {
    position: fixed; /* Sit on top of the page content */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
    z-index: 1000; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
}
</style>
